/**
 * «Elenco | Mappa»: le due viste delle aziende della console, una accanto all'altra (Simone, 27/10/2026: la mappa «in
 * prossimità della pagina in cui ci sono tutti i tenant»). Sono due indirizzi veri (`/tenants` e `/tenants/mappa`),
 * così la mappa si apre anche da un segnalibro e il tasto «indietro» del browser fa quello che ci si aspetta.
 */
import React from 'react';
import { Box, ButtonBase } from '@mui/material';
import { FormatListBulleted, Map as IconaMappa } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { tokens } from '../../theme';

export const PERCORSO_ELENCO_AZIENDE = '/tenants';
export const PERCORSO_MAPPA_AZIENDE = '/tenants/mappa';

export const InterruttoreVista: React.FC<{ attiva: 'elenco' | 'mappa' }> = ({ attiva }) => {
  const { t } = useTranslation('mappa');
  const navigate = useNavigate();
  const voci = [
    { id: 'elenco' as const, testo: t('pagina.elenco'), icona: <FormatListBulleted sx={{ fontSize: 17 }} />, a: PERCORSO_ELENCO_AZIENDE },
    { id: 'mappa' as const, testo: t('pagina.mappa'), icona: <IconaMappa sx={{ fontSize: 17 }} />, a: PERCORSO_MAPPA_AZIENDE },
  ];
  return (
    <Box
      role="group"
      aria-label={t('pagina.vista')}
      sx={{
        display: 'inline-flex',
        p: '3px',
        gap: '3px',
        borderRadius: `${tokens.radius.pill}px`,
        bgcolor: tokens.color.paper,
        border: `1px solid ${tokens.color.line}`,
      }}
    >
      {voci.map((v) => {
        const accesa = v.id === attiva;
        return (
          <ButtonBase
            key={v.id}
            aria-pressed={accesa}
            onClick={() => { if (!accesa) navigate(v.a); }}
            sx={{
              minHeight: 34,
              px: 1.5,
              gap: 0.75,
              borderRadius: `${tokens.radius.pill}px`,
              fontFamily: tokens.font.body,
              fontSize: '0.8rem',
              fontWeight: 600,
              color: accesa ? tokens.color.paper : tokens.color.ash,
              bgcolor: accesa ? tokens.color.graphite : 'transparent',
              transition: 'background-color 160ms ease, color 160ms ease',
              '&:hover': { color: accesa ? tokens.color.paper : tokens.color.graphite },
              '&.Mui-focusVisible': { outline: `2px solid ${tokens.color.graphite}`, outlineOffset: 2 },
            }}
          >
            {v.icona}
            {v.testo}
          </ButtonBase>
        );
      })}
    </Box>
  );
};
